import React from 'react'
import DocumentListItemColumn from './DocumentListItemColumn'
import styles from './DocumentList.module.scss'

const DocumentListHeaders = props => (
  <div className={styles.DocumentListHeaders}>
    <DocumentListItemColumn
      data-test-id="document-name-header"
      header="Name"
      className={styles.fileName}
      isListHeader={true} />
    <DocumentListItemColumn
      data-test-id="document-type-header"
      header="Type"
      className={styles.fileType}
      isListHeader={true} />
    <DocumentListItemColumn
      data-test-id="document-date-header"
      header="Date Uploaded"
      className={styles.dateShared}
      isListHeader={true} />
  </div>
)

export default DocumentListHeaders



// WEBPACK FOOTER //
// ./src/components/Client/DocumentList/DocumentListHeaders.jsx